/**
 * Español — Backoffice SuperAdmin
 */
export default {
  nav: {
    dashboard: 'Inicio',
    organizations: 'Organizaciones',
    users: 'Usuarios',
    timeEntries: 'Fichajes',
    audit: 'Auditoría',
    security: 'Seguridad',
    changePassword: 'Cambiar Contraseña',
    backofficeSubtitle: 'Backoffice — SuperAdmin',
    openMenu: 'Abrir menú',
    backups: 'Respaldos',
    notifDiagnostics: 'Diagnóstico de notificaciones',
    systemStatus: 'Estado del Sistema'
  },
  navSections: {
    general: 'General',
    management: 'Gestión',
    security: 'Seguridad'
  },
  login: {
    title: 'ChatIN Clock',
    subtitle: 'Backoffice — Acceso SuperAdmin',
    email: 'Email',
    password: 'Contraseña',
    emailPlaceholder: 'tu@email.com',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    show: 'Mostrar',
    hide: 'Ocultar',
    logoAlt: 'Logo de ChatIN Clock',
    submit: 'Entrar',
    submitting: 'Entrando…',
    secureAccess: 'Acceso seguro al panel',
    footer: 'Todas las acciones quedan registradas y monitoreadas.',
    errorCredentials: 'Credenciales inválidas',
    errorRateLimit: 'Demasiados intentos. Espera unos minutos y vuelve a intentar.'
  },
  password: {
    changeTitle: 'Cambiar contraseña',
    changeDescription: 'Actualiza la contraseña de tu cuenta.',
    current: 'Contraseña actual',
    new: 'Nueva contraseña',
    confirm: 'Confirmar contraseña',
    currentPlaceholder: 'Introduce la contraseña actual',
    newPlaceholder: 'Introduce la nueva contraseña',
    confirmPlaceholder: 'Confirma la nueva contraseña',
    changeButton: 'Cambiar contraseña',
    changing: 'Cambiando…',
    success: 'Contraseña actualizada correctamente',
    error: 'Error al actualizar la contraseña',
    requirements: 'Requisitos de contraseña',
    minLength: 'Mínimo {min} caracteres',
    complexity: 'Al menos 3 de: mayúsculas, minúsculas, números, caracteres especiales',
    noCommon: 'No usar contraseñas comunes',
    noSequences: 'No usar secuencias obvias (123, abc, qwerty)',
    weak: 'Débil',
    medium: 'Media',
    strong: 'Fuerte',
    tipsTitle: 'Consejos de seguridad',
    tipStrong: 'Usa una contraseña segura',
    tipReuse: 'Evita reutilizar contraseñas',
    tipManager: 'Usa un gestor de contraseñas'
  },
  common: {
    loading: 'Cargando…',
    save: 'Guardar',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    reset: 'Restablecer',
    all: 'Todos',
    search: 'Buscar',
    next: 'Siguiente',
    previous: 'Anterior',
    logout: 'Salir',
    of: 'de',
    page: 'Página',
    results: 'resultados',
    noResults: 'Sin resultados',
    error: 'Error',
    showIds: 'Mostrar IDs',
    copied: 'Copiado',
    copy: 'Copiar'
  },
  actions: {
    actions: 'Acciones',
    viewDetails: 'Ver detalles',
    view: 'Ver',
    close: 'Cerrar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    confirm: 'Confirmar'
  },
  dashboard: {
    title: 'Inicio',
    subtitle: 'Resumen de la plataforma',
    loading: 'Cargando dashboard…',
    activeOrgs: 'Organizaciones activas',
    activeOrgsOf: 'de {total} total',
    activeUsers: 'Usuarios activos',
    entriesToday: 'Fichajes hoy',
    quickActions: 'Acciones rápidas',
    quickActionsDesc: 'Atajos a las tareas administrativas más comunes.',
    createOrg: 'Crear organización',
    createUser: 'Crear usuario',
    viewOrgs: 'Ver organizaciones',
    viewUsers: 'Ver usuarios',
    viewEntries: 'Ver fichajes',
    openAudit: 'Abrir auditoría',
    securitySettings: 'Seguridad',
    changePassword: 'Cambiar mi contraseña',
    recentActivity: 'Actividad reciente',
    viewAll: 'Ver todo',
    noRecentActivity: 'Aún no hay actividad reciente.',
    platformShortcuts: 'Atajos de plataforma',
    manageOrgs: 'Gestionar organizaciones',
    manageUsers: 'Gestionar usuarios',
    reviewAudit: 'Revisar auditoría',
    systemStatus: 'Estado del sistema',
    apiStatus: 'Estado de API',
    lastDeployment: 'Último despliegue',
    twoFaAvailable: 'Disponibilidad 2FA',
    statusOk: 'OK'
  },
  orgCards: {
    access: 'Acceso: {plan}{until}',
    accessUntil: ' hasta {until}',
    accessTitle: 'Acceso',
    until: 'hasta {date}',
    plan: 'Plan: {plan} • {source}',
    planTitle: 'Plan',
    planLabel: 'Plan',
    planSource: 'Origen del plan',
    status: 'Estado',
    trial: 'Fin del trial: {date}',
    trialLabel: 'Fin del trial',
    grace: 'Fin de gracia: {date}',
    graceLabel: 'Fin de gracia',
    override: 'Override: {plan} hasta {date}',
    overrideLabel: 'Override',
    overrideNone: 'Override: —',
    none: '—',
    historyTitle: 'Trial / Gracia / Override',
    colDate: 'Fecha',
    colAction: 'Acción',
    colReason: 'Motivo',
    colMeta: 'Metadata',
    noAudit: 'Sin registros de auditoría.'
  },
  orgActions: {
    grant7: '+7 días',
    grant14: '+14 días',
    grant30: '+30 días',
    grantPro30: 'Pro 30 días',
    removeGrace: 'Quitar gracia',
    removeOverride: 'Quitar override',
    setTrial: 'Fijar fin de trial',
    extendStripeTrial: 'Extender trial en Stripe',
    extendStripeTrialPrompt: 'Días de trial en Stripe',
    extendStripeTrialToast: 'Trial de Stripe actualizado',
    extendStripeTrialDbOnlyToast:
      'Trial aplicado en el sistema. En Stripe la suscripción sigue «incomplete»: revisa el Dashboard o cancela el checkout pendiente.',
    endStripeTrial: 'Terminar trial en Stripe',
    quickEndTrial: 'Fin trial',
    quickEndTrialTitle: 'Terminar trial ahora (misma acción que abajo)',
    endStripeTrialConfirm: 'Terminar trial en Stripe ahora?',
    endStripeTrialToast: 'Trial terminado en Stripe',
    stripeTrialBlocked: 'Stripe no permite modificar el trial en este estado',
    stripeStatus: 'Estado Stripe',
    viewDetails: 'Ver detalles',
    cancelSubscription: 'Cancelar suscripción',
    pauseSubscription: 'Pausar suscripción',
    resumeSubscription: 'Reanudar suscripción',
    openStripe: 'Abrir cliente Stripe',
    configureStripe: 'Configurar Stripe',
    stripeCustomerId: 'Stripe Customer ID',
    stripeSubscriptionId: 'Stripe Subscription ID',
    stripeIdsRequired: 'Ingresa Customer o Subscription',
    stripeLinked: 'Stripe actualizado',
    forceSync: 'Forzar sincronización Stripe',
    sectionManage: 'Gestión',
    sectionSubscription: 'Suscripción',
    sectionPlan: 'Plan',
    sectionSystem: 'Sistema',
    sectionDanger: 'Peligro',
    sectionPrimary: 'Acciones principales',
    sectionSubscriptionMgmt: 'Gestión de suscripción',
    sectionTrialGrace: 'Trial / gracia',
    sectionDangerZone: 'Zona de riesgo'
  },
  billingOverride: {
    sectionTitle: 'Billing manual',
    activate: 'Activar acceso',
    deactivate: 'Desactivar acceso',
    extend: 'Extender acceso',
    trial: 'Trial manual',
    clear: 'Quitar override',
    label: 'Billing',
    finalStatus: 'Estado final billing',
    promptDays: 'Días de acceso',
    promptReason: 'Motivo (opcional)',
    invalidDays: 'Días inválidos',
    confirmClear: 'Quitar override manual?',
    toastActivated: 'Acceso activado',
    toastDeactivated: 'Acceso desactivado',
    toastExtended: 'Acceso extendido',
    toastTrial: 'Trial manual aplicado',
    toastCleared: 'Override quitado',
    until: 'hasta {date}',
    status: {
      active: 'activo',
      inactive: 'inactivo',
      trial: 'trial'
    },
    source: {
      manual: 'manual',
      stripe: 'stripe',
      trial: 'trial',
      system: 'sistema'
    }
  },
  orgTrialModal: {
    title: 'Fijar fin de trial',
    labelDate: 'Fin del trial (hora local)',
    placeholderDate: 'Selecciona fecha y hora',
    labelReason: 'Motivo (obligatorio)',
    placeholderReason: 'Explica por qué cambias el trial',
    save: 'Guardar',
    saving: 'Guardando…',
    cancel: 'Cancelar',
    errorRequired: 'Fecha y motivo son obligatorios'
  },
  orgDeleteModal: {
    title: 'Eliminar organización',
    warningTitle: '⚠️ Esta acción es irreversible.',
    warningIntro: 'Se eliminarán:',
    itemOrg: 'La organización',
    itemUsers: 'Todos los usuarios',
    itemTime: 'Todos los registros de tiempo',
    itemData: 'Toda la información asociada',
    confirmTitle: 'Confirmación',
    orgNameHint: 'Nombre de la organización: {name}',
    placeholder: 'Escribe el nombre de la organización para confirmar',
    acknowledge: 'Entiendo que esta acción no se puede deshacer',
    confirmDelete: 'Eliminar definitivamente'
  },
  org: {
    title: 'Organizaciones',
    subtitle: 'Multicliente: listado de todas las organizaciones',
    searchPlaceholder: 'Buscar por nombre o ID…',
    empty: 'No hay organizaciones',
    createNew: 'Crear organización',
    planChangeTitle: 'Cambiar plan',
    planRequired: 'Selecciona un plan',
    nameLabel: 'Nombre',
    adminName: 'Nombre admin',
    adminNamePlaceholder: 'Nombre de la persona admin',
    adminEmail: 'Email del administrador',
    adminPassword: 'Contraseña inicial',
    adminPasswordConfirm: 'Confirmar contraseña',
    errorEmailRequired: 'Email requerido',
    errorPasswordRequired: 'La contraseña debe tener al menos 6 caracteres',
    errorPasswordMatch: 'Las contraseñas no coinciden',
    name: 'Nombre',
    namePlaceholder: 'Nombre de la organización',
    plan: 'Plan',
    status: 'Estado',
    users: 'Usuarios',
    createdAt: 'Creada',
    created: 'Organización creada',
    statusActive: 'Activa',
    statusPaused: 'Pausada',
    statusSuspended: 'Suspendida',
    create: 'Crear organización',
    edit: 'Editar organización',
    activate: 'Activar',
    deactivate: 'Desactivar',
    delete: 'Eliminar organización',
    confirmDelete: 'Esto eliminará la organización y todos sus usuarios.',
    deleted: 'Organización eliminada',
    confirmCancelSub: '¿Cancelar la suscripción de esta organización?',
    confirmPauseSub: '¿Pausar la facturación de esta organización?',
    confirmResumeSub: '¿Reanudar la facturación de esta organización?',
    toastCancelled: 'Suscripción cancelada',
    toastPaused: 'Suscripción pausada',
    toastResumed: 'Suscripción reanudada',
    toastSynced: 'Billing sincronizado',
    confirmDeactivate: '¿Desactivar esta organización? Quedará suspendida.',
    confirmActivate: '¿Activar esta organización?',
    planPlaceholder: 'ej. enterprise',
    planStarter: 'Starter',
    planGrowth: 'Growth',
    planEnterprise: 'Enterprise',
    planBusiness: 'Business',
    planLabelMap: {
      starter: 'Starter',
      growth: 'Growth',
      business: 'Business',
      enterprise: 'Enterprise',
      basic: 'Basic'
    },
    badgeTrial: 'TRIAL',
    usersLabel: 'usuarios',
    planUsersLabel: 'Usuarios',
    planUsersLimit: 'hasta {count} {label}',
    planUsersPlaceholder: 'Ej. 20',
    planTrialDaysLabel: 'Días de prueba (opcional)',
    planTrialDaysPlaceholder: 'Ej. 14',
    planReasonLabel: 'Motivo (requerido)',
    planReasonPlaceholder: 'Describe el motivo del cambio',
    accessUntil: 'acceso hasta {date}',
    slug: 'Slug / Código',
    slugPlaceholder: 'codigo-org',
    slugHelp: 'Se usa en URLs y referencias internas.',
    timezone: 'Zona horaria',
    language: 'Idioma por defecto',
    languageEn: 'Inglés',
    languageEs: 'Español',
    contactEmail: 'Email de contacto',
    contactEmailPlaceholder: 'admin@empresa.com',
    billingEmail: 'Email de facturación',
    billingEmailPlaceholder: 'facturacion@empresa.com',
    country: 'País',
    countryPlaceholder: 'España',
    phone: 'Teléfono',
    phonePlaceholder: '+34 600 000 000',
    maxUsers: 'Máximo de usuarios',
    maxUsersPlaceholder: 'ej. 250',
    notes: 'Notas',
    notesPlaceholder: 'Notas internas',
    sectionDetails: 'Detalles de la organización',
    sectionContact: 'Contacto y facturación',
    sectionLimits: 'Límites y ajustes',
    optional: 'Opcional',
    optionalTooltip: 'Campo opcional',
    errorNameRequired: 'El nombre es obligatorio.',
    errorNameMin: 'El nombre debe tener al menos 2 caracteres.',
    errorSlugRequired: 'El slug es obligatorio.',
    errorSlugMin: 'El slug debe tener al menos 2 caracteres.',
    errorSlugInvalid: 'El slug solo puede incluir minúsculas, números y guiones.',
    errorContactEmailRequired: 'El email de contacto es obligatorio.',
    errorContactEmailInvalid: 'Introduce un email válido.',
    errorBillingEmailInvalid: 'Introduce un email de facturación válido.',
    errorTimezoneRequired: 'La zona horaria es obligatoria.',
    errorLanguageRequired: 'El idioma es obligatorio.',
    errorFixForm: 'Corrige los campos marcados.',
    orgId: 'ID org'
  },
  users: {
    adminEmail: 'Email admin',
    title: 'Usuarios',
    subtitle: 'Todos los usuarios de la plataforma',
    searchPlaceholder: 'Buscar por nombre o email…',
    empty: 'No hay usuarios',
    name: 'Nombre',
    email: 'Email',
    organization: 'Organización',
    role: 'Rol',
    createdAt: 'Creado',
    create: 'Crear usuario',
    edit: 'Editar',
    delete: 'Eliminar',
    deleting: 'Eliminando…',
    deleteImpact: 'Se cerrarán sesiones activas y el usuario no podrá iniciar sesión. Esta acción no se puede deshacer en la UI.',
    confirmDeleteStrong: 'Escribe el email del usuario para habilitar Eliminar:',
    deactivate: 'Desactivar',
    activate: 'Activar',
    resetPassword: 'Restablecer contraseña',
    moveOrg: 'Mover organización',
    changeRole: 'Cambiar rol',
    active: 'Activo',
    inactive: 'Inactivo',
    newPassword: 'Nueva contraseña',
    newPasswordPlaceholder: 'Mínimo 6 caracteres',
    confirmPassword: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repite la contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    filterAllRoles: 'Todos los roles',
    filterAllStatus: 'Todos los estados',
    sortNewest: 'Más nuevos',
    sortOldest: 'Más antiguos',
    sortNameAsc: 'Nombre A-Z',
    sortNameDesc: 'Nombre Z-A',
    sortRole: 'Rol',
    sortOrg: 'Organización',
    filterOrgAll: 'Organización (Todos)',
    filterRolesAll: 'Todos los roles',
    filterStatesAll: 'Todos los estados',
    emptyFiltered: 'No hay usuarios que coincidan con los filtros.',
    selectOrg: 'Seleccionar organización',
    roleEmployee: 'Empleado',
    roleAdmin: 'Administrador',
    roleSupervisor: 'Supervisor',
    roleSuperadmin: 'Superadmin',
    roleOwner: 'Dueño',
    confirmDelete: '¿Eliminar este usuario? Esta acción no se puede deshacer.',
    confirmDeactivate: '¿Desactivar este usuario? Perderá acceso hasta reactivarlo.',
    confirmActivate: '¿Activar este usuario y restaurar su acceso?',
    userId: 'ID usuario',
    orgId: 'ID org'
  },
  timeEntries: {
    title: 'Fichajes',
    subtitle: 'Time entries de todas las organizaciones',
    empty: 'No hay fichajes',
    from: 'Desde',
    to: 'Hasta',
    user: 'Usuario',
    organization: 'Organización',
    clockIn: 'Entrada',
    clockOut: 'Salida',
    hours: 'Horas',
    status: 'Estado',
    statusCompleted: 'Completado',
    statusActive: 'En progreso',
    statusError: 'Error',
    filterByOrg: 'Organización',
    filterByUser: 'Usuario',
    exportCsv: 'Exportar CSV'
  },
  audit: {
    title: 'Auditoría',
    subtitle: 'Registro de acciones del backoffice (quién, qué, cuándo, IP)',
    empty: 'No hay registros de auditoría',
    events: {
      dashboard_view: 'Dashboard visto',
      preferences_update: 'Preferencias actualizadas',
      superadmin_login_success: 'Inicio de sesión de superadmin',
      organization_created: 'Organización creada',
      organization_updated: 'Organización actualizada',
      organization_deleted: 'Organización eliminada',
      organization_activated: 'Organización activada',
      organization_deactivated: 'Organización desactivada',
      user_created: 'Usuario creado',
      user_updated: 'Usuario actualizado',
      user_deleted: 'Usuario eliminado',
      password_changed: 'Contraseña cambiada',
      password_reset_requested: 'Restablecimiento de contraseña solicitado',
      twofa_enabled: '2FA activado',
      twofa_disabled: '2FA desactivado'
    },
    actorFilter: 'Actor',
    actorFilterPlaceholder: 'Buscar por actor…',
    actionFilter: 'Acción',
    actionFilterPlaceholder: 'Filtrar por acción…',
    clearFilters: 'Limpiar filtros',
    exportCsv: 'Exportar CSV',
    date: 'Fecha',
    actor: 'Actor',
    action: 'Acción',
    resource: 'Recurso',
    ip: 'IP',
    result: 'Resultado',
    resultOk: 'ok',
    resultError: 'error',
    resultWarning: 'advertencia',
    metadata: 'Detalle',
    before: 'Antes',
    after: 'Después'
  },
  notifDiagnostics: {
    title: 'Diagnóstico de Notificaciones',
    subtitle: 'Eventos de notificaciones backend/app de todos los tipos; la correlación automática es más confiable para recordatorios (fin de pausa, entrada/salida pendiente) — otros tipos pueden listarse por separado',
    empty: 'No hay registros de diagnóstico de notificaciones',
    userIdFilterPlaceholder: 'Filtrar por userId…',
    dedupeKeyFilterPlaceholder: 'Filtrar por dedupeKey…',
    notifTypeFilterPlaceholder: 'Tipo',
    notifTypeAll: 'Todos los tipos',
    search: 'Buscar',
    user: 'Usuario',
    backendEvents: 'Backend',
    clientEvents: 'App (cliente)',
    noBackendEvents: 'Sin eventos de backend',
    noClientEvents: 'Sin eventos de cliente',
    failed: 'FALLÓ',
    type: 'tipo',
    unknownDate: 'Fecha desconocida',
    noDedupeKey: 'Sin clave de agrupación (no filtrable por dedupeKey)'
  },
  systemStatus: {
    title: 'Estado del Sistema',
    subtitle: 'Errores recientes del backend y de la app, y salud general — se actualiza sola cada 5 segundos',
    healthServer: 'Servidor',
    healthDb: 'Base de datos',
    healthUptime: 'Activo desde hace',
    statusOk: 'OK',
    statusError: 'ERROR',
    empty: 'Sin errores recientes',
    sourceFilterLabel: 'Origen',
    severityFilterLabel: 'Severidad',
    filterAll: 'Todos',
    sourceBackend: 'Backend',
    sourceClient: 'App (client)',
    severityError: 'Error',
    severityWarning: 'Warning',
    backendBadge: 'Backend',
    clientBadge: 'App',
    userLabel: 'Usuario'
  },
  search: {
    placeholder: 'Buscar organización, usuario, proyecto…',
    sections: {
      organizations: 'Organizaciones',
      users: 'Usuarios',
      projects: 'Proyectos'
    },
    noResults: 'Sin resultados'
  },
  toast: {
    saved: 'Guardado',
    error: 'Algo ha fallado',
    created: 'Creado',
    deleted: 'Eliminado',
    updated: 'Actualizado',
    passwordReset: 'Contraseña actualizada'
  },
  twoFa: {
    title: 'Autenticación en dos pasos',
    subtitle: 'Usa una app de autenticación (Google Authenticator, Authy) o códigos de recuperación.',
    status: 'Estado',
    enabled: '2FA está activado.',
    disabled: '2FA no está activado.',
    enable: 'Activar 2FA',
    disable: 'Desactivar 2FA',
    scanQr: 'Escanea este código QR con tu app o introduce el código manualmente.',
    manualCode: 'Código manual',
    enterCode: 'Introduce el código de 6 dígitos de tu app',
    confirm: 'Confirmar',
    recoveryCodes: 'Códigos de recuperación (guárdalos; no se volverán a mostrar)',
    recoveryCodesDesc: 'Cada código se puede usar una vez si pierdes acceso a tu app.',
    disablePassword: 'Tu contraseña',
    disableCode: 'Código 2FA actual o código de recuperación',
    disableConfirm: 'Desactivar 2FA'
  },
  security: {
    overviewTitle: 'Resumen de seguridad',
    accountEmail: 'Email de la cuenta',
    twoFactor: 'Autenticación en dos pasos',
    enabled: 'Activado',
    disabled: 'Desactivado',
    lastLogin: 'Último acceso',
    lastLoginIp: 'IP del último acceso',
    authApp: 'App autenticadora',
    recoveryCodes: 'Códigos de recuperación',
    available: 'Disponibles',
    notGenerated: 'No generados',
    recoveryTitle: 'Códigos de recuperación',
    recoveryDesc: 'Puedes usar los códigos si pierdes acceso a tu autenticador.',
    viewRecovery: 'Ver códigos de recuperación',
    generateRecovery: 'Generar códigos de recuperación',
    dangerTitle: 'Zona de peligro',
    dangerDesc: 'Desactivar 2FA reducirá la seguridad de esta cuenta.',
    disableModalTitle: '¿Desactivar autenticación en dos pasos?',
    disableModalText: 'Esto reducirá la seguridad de la cuenta.',
    disableConfirm: 'Desactivar'
  },
  backups: {
    title: 'Copias de Seguridad',
    subtitle: 'Administra y descarga los respaldos de la base de datos de producción.',
    listTitle: 'Copias de seguridad disponibles',
    name: 'Nombre del archivo',
    size: 'Tamaño',
    date: 'Fecha de creación',
    actions: 'Acciones',
    download: 'Descargar',
    createBtn: 'Crear respaldo manual',
    creating: 'Creando respaldo...',
    noBackups: 'No se encontraron copias de seguridad.',
    successCreated: 'Respaldo creado con éxito',
    errorLoad: 'Error al cargar las copias de seguridad',
    errorCreate: 'Error al crear la copia de seguridad',
    backupsDir: 'Directorio en el servidor'
  }
};
